import { GameClient, podOriginName } from "../net";
import { esc } from "./util";

// Pod Rotation: the full game-schedule overlay (opened from the game menu).
// Reflects the live schedule — round advances, swing moves — with the current
// round highlighted and "YOU" marks on the player's own pod/squad each round.

function cardHtml(client: GameClient): string {
  const p = client.pod!;
  const s = p.schedule!;
  const me = client.identity.sub;
  const nm = (id: string) => esc(p.names?.[id] || id.slice(0, 5));
  const you = (ids: string[]) => (ids.includes(me) ? ` <span class="pod-you">YOU</span>` : "");
  const rounds = s.pods.map((pod, i) => {
    const squads = s.rounds[i] || [];
    const state = i === p.roundIdx ? "cur" : i < p.roundIdx ? "done" : "";
    const tag = i === p.roundIdx ? " · NOW" : i < p.roundIdx ? " · done" : "";
    return `<div class="pod-sched-round ${state}">
      <div class="pod-sched-rh">ROUND ${i + 1}${tag}</div>
      <div class="pod-sched-line hide"><b>Hiding pod:</b> ${pod.map(nm).join(", ")}${you(pod)}</div>
      ${squads.map((sq, j) => `<div class="pod-sched-line">Squad ${String.fromCharCode(65 + j)}: ${sq.map(nm).join(", ")}${you(sq)}</div>`).join("")}
    </div>`;
  }).join("");
  const done = p.roundIdx >= s.pods.length;
  return `<div class="pod-sched-card">
    <div class="pod-sched-top"><span>GAME SCHEDULE</span><button id="pod-sched-close" aria-label="Close">×</button></div>
    ${!done ? `<div class="pod-sched-origin">Round ${p.roundIdx + 1} — pod started near: <b>${esc(podOriginName(p.origin))}</b></div>` : ""}
    ${done ? `<div class="pod-sched-origin">Game complete · ${s.pods.length} rounds played</div>` : ""}
    <div class="pod-sched-list jl-scroll">${rounds}</div>
  </div>`;
}

/** Open the full schedule overlay; refreshes live while open. No-op off Pod Rotation. */
export function openPodScheduleOverlay(client: GameClient) {
  if (!client.pod?.schedule) return;
  document.querySelector("#info-modal")?.remove(); // don't stack with Game info
  document.querySelector("#pod-sched-ov")?.remove();
  document.body.insertAdjacentHTML("beforeend", `<div class="pod-sched-ov" id="pod-sched-ov"></div>`);
  const ov = document.querySelector<HTMLElement>("#pod-sched-ov")!;
  let unsub = () => {};
  const close = () => { ov.remove(); unsub(); };
  const paint = () => {
    if (!document.body.contains(ov)) { unsub(); return; }
    ov.innerHTML = cardHtml(client);
    ov.querySelector("#pod-sched-close")?.addEventListener("click", close);
  };
  ov.addEventListener("click", (e) => { if (e.target === ov) close(); });
  unsub = client.subscribe(paint); // fires once immediately, then on every update
}
